import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';

interface AuthState {
  // 認証状態
  session: Session | null;
  user: User | null;
  loading: boolean;

  // アクション
  setSession: (session: Session | null) => void;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  // 初期状態
  session: null,
  user: null,
  loading: true,

  // アクション
  setSession: (session) => set({ session, user: session?.user ?? null }),
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
  signOut: () => set({ session: null, user: null }),
}));
